'use strict';

const React = require('react');
const ReactDOM = require('react-dom');
import PropTypes from 'prop-types';
const uuid = require('uuid');
const _ = {
    assign:     require('lodash/assign'),
    clone:      require('lodash/clone'),
    filter:     require('lodash/filter'),
    find:       require('lodash/find'),
    findIndex:  require('lodash/findIndex'),
    isEmpty:    require('lodash/isEmpty'),
    isEqual:    require('lodash/isEqual'),
    map:        require('lodash/map'),
};

function genId(prefix) {
    return (prefix||'') + uuid.v4()
}

const Strings = require('../../../../../app/shared/Strings');
const Globals = require('../../../../../app/globals');
const ShortCourseConstants = require('../../../../../app/shared/ShortCourseConstants');

const ShortCourseEditorActions = require('../../../actions/ShortCourseEditorActions');
const ShortCourseEditorStore = require('../../../stores/ShortCourseEditorStore');

//const CollaboratorActions = require('../../../actions/CollaboratorActions');
//const CollaboratorStore = require('../../../stores/CollaboratorStore');

// for toLocaleString
const date_format_options = {month:'numeric', day: 'numeric', year:'2-digit', hour12:true, hour:'numeric',minute:'numeric'};//,second:'numeric'}

const propTypes = {
	openConfirmDialog: PropTypes.func.isRequired,
    commentInfo: PropTypes.object.isRequired,
    describeCommentLocation: PropTypes.func.isRequired,
    refreshComments: PropTypes.func.isRequired,
    commentAction: PropTypes.func.isRequired,
};

const defaultProps = {};

class ReviewCommentEditor extends React.Component {
    constructor(props) {
        super(props);
        
        var storeState = ShortCourseEditorStore.getState();
        var currentNav = storeState.currentNav;
        
        const user_id = props.userHash;
        const rawComments = props.commentInfo && props.commentInfo.shortCourseComments;
        const assignees = this.getPossibleAssignees(props);
        const default_assignee = user_id; // (assignees.length === 1) ? assignees[0].user_id : '';
        const permissions = props.commentInfo && props.commentInfo.permissions;

        var loc_option = 'global'; // 'node';
        var assignee_id = user_id; // 'all';
        var creator_id = 'all';
        var status = 'OPEN';
        var filters = {
            location: this.makeFilterLocation(currentNav,loc_option),
            status: status,
            assignee_id: assignee_id,
            creator_id: creator_id,
        };
        var selected_comment = storeState.selectedCommentTopicID;
        var selected_reply = '';
        var [active_element_comment, active_element_status, active_element_assignee_id] = this.getActiveElementEditData(selected_comment,selected_reply);
        this.state = {
            rawComments,
            currentNav,
            comments: this.getStoreComments(props, rawComments, filters, "constructor"),
            assignees,
            user_id,
            selected_comment, // set when an existing comment has been selected.  Not set when a new reply is being added (uses newReplyParentID instead)
            selected_reply,
            
            // possibly edited data for the selected topic or reply
            active_element_comment,     // could be c.comment or r.comment
            active_element_status,      // topic status whether it's a comment or a reply
            active_element_assignee_id, // topic assignee_id whether it's a comment or a reply
            
            // filter values
            filter_status: status,
            filter_assignee_id: assignee_id,
            filter_creator_id: creator_id,
            filter_loc_option: loc_option,
            sortBy: 'modified_at',
            sortDown: true,
            
            // edit mode values
            editingOldText: false, // true if we're editing text for an existing comment or reply
            showNewCommentEditor: false, // true if we're adding a new topic
            newReplyParentID: '', // set if we're adding a new reply
            
            default_assignee,
            permissions,
            
        };
    }
    
    componentDidMount(){
        this.unsubscribes = [
            ShortCourseEditorStore.listen(this.onStoreChange),
        ]        
        const storeState = ShortCourseEditorStore.getState();
        this.onStoreChange(storeState);
    }
    
    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }
    
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.commentInfo !== this.props.commentInfo) {
            const storeState = ShortCourseEditorStore.getState();
            this.onStoreChange(storeState,nextProps);
        }
    }
    
    /*doesLocMatchFilter=(loc,filterLoc)=>{
        if (!filterLoc) {
            return true; // no location filter
        }
        
        if (!loc) {
            return false;
        }
        if(loc.type !== filterLoc.type) {
            return false;
        }
        
        var filter_has_node_id = this.isLocationIdSomething(filterLoc.id);
        
        if (typeof filterLoc.id !== 'undefined') {
            var c_has_node_id = this.isLocationIdSomething(loc.id);
            if (filter_has_node_id && c_has_node_id) {
                if (loc.id !== filterLoc.id) {
                    return false;
                }
            }
            if (filter_has_node_id !== c_has_node_id) {
                return false;
            }
        }
    }*/
    
    anyActiveCommentChanges=(active_element_comment, active_element_status, active_element_assignee_id)=>{
        if (typeof active_element_comment === 'undefined') {
            [active_element_comment, active_element_status, active_element_assignee_id] = this.getActiveElementEditData(this.state.selected_comment,this.state.selected_reply);
        }
        if (this.state.active_element_comment || this.state.active_element_status || this.state.active_element_assignee_id) {
            if ((active_element_comment !== this.state.active_element_comment) ||
                (active_element_status !== this.state.active_element_status) ||
                (active_element_assignee_id !== this.state.active_element_assignee_id) ) {
                return true;
            }
        }
        return false;
    }
    
    /*doScrollToComment=(comment_id)=>{
        var scroll_ref = 'scrollto_' + comment_id;
        var elem = ReactDOM.findDOMNode(this.refs[scroll_ref]);
        if (elem) {
            var scrollAreaElem = ReactDOM.findDOMNode(this.refs.csa);
            if (!scrollAreaElem) {
                console.log("ERROR! Didn't find scrollAreaElem");
                elem.scrollIntoView(); // fallback
                return;
            }
            var cy = elem.offsetTop - scrollAreaElem.offsetTop;
            scrollAreaElem.scrollTop = Math.floor(cy);
        }
        else {
            console.log("didn't find " + scroll_ref);
        }
    }*/
    
    getComment=(comment_id)=>{
        if (!this.state) {
            return;
        }
        return _.find(this.state.rawComments,{id:comment_id});
    }
    
    getUserNameFromId=(user_id)=>{
        let query = {user_id};
        let u = _.find(this.props.possibleAssignees,query);
        if (!u) {
            u = _.find(this.props.otherAssignees,query);
        }
        return u ? u.display_name : '';
    }
    
    /*onScrollToComment=(comment_id)=>{
        var filter_loc = this.state.currentNav;
        var filter_status = this.state.filter_status;
        var filter_assignee_id = this.state.filter_assignee_id;
        var filter_creator_id = this.state.filter_creator_id;
        var filter_loc_option = this.state.filter_loc_option;
        var comment = this.getComment(comment_id);
        if (!comment) {
            return;
        }
        
        var current_floc = this.makeFilterLocation(filter_loc,this.state.filter_loc_option)
//        var matches = _.filter(this.state.comments,(c)=>{
//            if (!this.doesLocMatchFilter(c.location,current_floc)) {
//                return false;
//            }
//        });
        if (this.doesLocMatchFilter(comment.location,current_floc)) {
            if (this.anyActiveCommentChanges()) {
                return; // don't do anything
            }

            // don't need to change our filter. Just update our selected comment
            if (comment.id === this.state.selected_comment) {
                // nothing needs to change except we're not editing any more
                this.setState({
                    editingOldText: false,
                },()=>{
                    this.doScrollToComment(comment_id);
                });
            }
            else {
                this.setState({
                    selected_comment: comment_id,
                    selected_reply: '',
                    active_element_comment: comment.comment,
                    active_element_status: comment.status,
                    active_element_assignee_id: comment.assignee_id,
                    editingOldText: false,
                },()=>{
                    this.doScrollToComment(comment_id);
                });
            }
            return;
        }
        
        // find raw comments that match our loc
        let matches = _.filter(this.state.rawComments,(c)=>{
            if (!this.doesLocMatchFilter(c.location,filter_loc)) {
                return false;
            }
        });
        
        if (matches.length === 0) {
            // we don't have any matches, so let's just set our filter as wide as possible for the specified loc
            filter_status = 'all';
            filter_assignee_id = 'all';
            filter_creator_id = 'all';
        }
        else {
            var status_matches;
            if (filter_status === 'all') {
                status_matches = matches;
            }
            else {
                status_matches = _.filter(matches,{status: filter_status});
            }
            
            var assignee_matches;
            if (filter_assignee_id === 'all') {
                assignee_matches = matches;
            }
            else {
                assignee_matches =  _.filter(matches,{assignee_id: filter_assignee_id});
            }
            
            var creator_matches;
            if (filter_creator_id === 'all') {
                creator_matches = matches;
            }
            else {
                creator_matches =  _.filter(matches,{user_id: filter_creator_id});
            }
            
            if (matches.length && (creator_matches.length === 0)) {
                filter_creator_id = 'all';
            }
            
            if (status_matches.length && (assignee_matches.length === 0)) {
                filter_assignee_id = 'all';
            }
            else if ((status_matches.length === 0) && assignee_matches.length) {
                if (filter_status !== 'OPEN') {
                    if (_.find(status_matches,{status: 'OPEN'})) {
                        filter_status = 'OPEN';
                    }
                    else {
                        filter_status = 'all';
                    }
                }
                else {
                    filter_status = 'all';
                }
            }
            else {
                // status and assignee filters both need to change
                if ((filter_status !== 'OPEN') && _.find(matches,{status:'OPEN'})) {
                    filter_status = 'OPEN';
                }
                else {
                    filter_status = 'all';
                }
                filter_assignee_id = 'all';
            }
        }
        
        var filters = {
            location: this.makeFilterLocation(filter_loc,this.state.filter_loc_option),
            status: filter_status,
            assignee_id: filter_assignee_id,
            creator_id: filter_creator_id,
        };
        var comments = this.getStoreComments(this.props,this.state.rawComments,filters,"goToComment");
        var [selected_comment, selected_reply, active_element_comment, active_element_status, active_element_assignee_id] = this.updateSelectedComment(comments,true);
        
        var stateChanges = {
            filter_loc_option: filter_loc_option,
            filter_status: filter_status,
            filter_assignee_id: filter_assignee_id,
            filter_creator_id: filter_creator_id,
            comments: comments,
            selected_comment: selected_comment,
            selected_reply: selected_reply,
            active_element_comment: active_element_comment,
            active_element_status: active_element_status, 
            active_element_assignee_id: active_element_assignee_id,
            editingOldText: false,
        };
        
        if (this.anyActiveCommentChanges(active_element_comment,active_element_status,active_element_assignee_id)) {
            this.props.openConfirmDialog("Navigating To Comment","You have unsaved changes. Continue navigating and lose changes?","yes",()=>{
                this.setState(stateChanges,()=>{
                    this.doScrollToComment(comment_id);
                    ShortCourseEditorActions.setSelectedCommentTopic(selected_comment);
                });
            });
            return; // only make the change if confirmed
        }
        this.setState(stateChanges,()=>{
            this.doScrollToComment(comment_id);
            ShortCourseEditorActions.setSelectedCommentTopic(selected_comment);
        });
    }*/
    
    getActiveElementEditData=(id,reply_id)=>{
        if (!id) {
            return ['','',''];
        }
        var c = this.getComment(id);
        if (!c) {
            return ['','',''];
        }
        if (reply_id) {
            var r = _.find(c.replies, {id: reply_id});
            if (r) {
                return [r.comment, c.status, c.assignee_id];
            }
            console.log("didn't find reply_id " + reply_id); // unexpected
            return ['','',''];
        }
        return [c.comment, c.status, c.assignee_id];
    }
    
    onStoreChange=(storeState,props)=>{
        if (!props) {
            props = this.props;
        }
        var currentNav = storeState.currentNav;
        const rawComments = props.commentInfo && props.commentInfo.shortCourseComments;
        const assignees = this.getPossibleAssignees(props);
        //const default_assignee = (assignees.length === 1) ? assignees[0].user_id : '';
        const permissions = props.commentInfo && props.commentInfo.permissions;
        
        var store_selected_comment = storeState.selectedCommentTopicID;
        var filter_loc = currentNav;
        var filter_loc_option = this.state.filter_loc_option;
        var select_a_comment = false;
        
        var changes = {};
        if (!_.isEqual(this.state.currentNav,currentNav)) {
            changes.currentNav = currentNav;
        }

        if (!_.isEqual(rawComments,this.state.rawComments) || changes.currentNav) {
            var filters = {
                location: this.makeFilterLocation(filter_loc,filter_loc_option),
                status: this.state.filter_status,
                assignee_id: this.state.filter_assignee_id,
                creator_id: this.state.filter_creator_id,
            };
            var comments = this.getStoreComments(props,rawComments, filters, "checkForStoreChanges");
            var [selected_comment, selected_reply, active_element_comment, active_element_status, active_element_assignee_id] = this.updateSelectedComment(comments,select_a_comment,store_selected_comment);
            var editingOldText = this.state.editingOldText;
            if ((this.state.selected_comment !== selected_comment) || (this.state.selected_reply !== selected_reply)) {
                editingOldText = false;
            }
            changes = _.assign(changes,{
                rawComments,
                comments,
                selected_comment,
                selected_reply,
                active_element_comment,
                active_element_status,
                active_element_assignee_id,
                editingOldText: editingOldText,
                // default_assignee,
            });
        }
        if (!_.isEqual(assignees, this.state.assignees)) {
            changes - _.assign(changes,{
                assignees: assignees
            });
        }
        if (!_.isEqual(permissions, this.state.permissions)) {
            changes - _.assign(changes,{
                permissions: permissions
            });
        }
        //if ((typeof store_selected_comment !== 'undefined') && this.state.selected_comment !== store_selected_comment) {
        //    changes.selected_comment = store_selected_comment;
        //}
        
        if (!_.isEmpty(changes)) { 
            this.setState(changes,()=>{
                if (changes.selected_comment) {
                    ShortCourseEditorActions.setSelectedCommentTopic(selected_comment);
                }
            });
        }
    }

    // validate selected_comment and return results of the validation so we can update our state.
    // called when filters or store comments change.
    // params:
    //   comments: array of comment data (possibly filtered)
    //   selectAnother: boolean. true if we should automatically select a different comment if selected_comment is not valid
    //   selected_comment: a comment id
    // returns:
    //  [selected_comment, selected_reply, active_element_comment, active_element_status, active_element_assignee_id] 
    updateSelectedComment=(comments,selectAnother,selected_comment)=>{
        var selected_reply = this.state.selected_reply;
        var active_element_comment = this.state.active_element_comment;
        var active_element_status = this.state.active_element_status;
        var active_element_assignee_id = this.state.active_element_assignee_id;
        if (typeof selected_comment === 'undefined') {
            selected_comment = this.state.selected_comment;
        }
        else {
            if (selected_comment !== this.state.selected_comment) {
                selected_reply = ''; // if we changed the selected comment, blank the reply
                [active_element_comment, active_element_status, active_element_assignee_id] = this.getActiveElementEditData(selected_comment,selected_reply);
            }
        }
        var test = _.find(comments,{id:selected_comment});
        if (!test) {
            selected_reply = '';
            if (selectAnother && comments.length) {
                // select the first comment
                selected_comment = comments[0].id;
            }
            else {
                selected_comment = '';
            }
            [active_element_comment, active_element_status, active_element_assignee_id] = this.getActiveElementEditData(selected_comment,selected_reply);
        }
        return [selected_comment,selected_reply,active_element_comment, active_element_status, active_element_assignee_id];
    }
    
    // return true if a nav location id is something.
    // return false if it is not.
    isLocationIdSomething=(id)=>{
        if (typeof id === 'undefined' || (id === -1) || (id === '')) {
            return false;
        }
        return true;
    }
    
    getStoreComments=(props, rawComments, filters, note)=>{
        if (!rawComments) {
            return [];
        }
        var filter_has_node_id = filters.location && this.isLocationIdSomething(filters.location.id);

        var filteredComments = _.filter(rawComments,(c)=>{
            if (filters.location !== null) {
                if (!c) {
                    console.log("rawComments has null entry?",JSON.stringify(rawComments)); // FIXME: remove debug spam
                    return false;
                }
                if (!c.location) {
                    return false;
                }
                if(c.location.type !== filters.location.type) {
                    return false;
                }
                
                if (typeof filters.location.id !== 'undefined') {
                    var c_has_node_id = this.isLocationIdSomething(c.location.id);
                    if (filter_has_node_id && c_has_node_id) {
                        if (c.location.id !== filters.location.id) {
                            return false;
                        }
                    }
                    if (filter_has_node_id !== c_has_node_id) {
                        return false;
                    }
                }
            }
            if (filters.status && filters.status !== 'all') {
                if (c.status !== filters.status) {
                    return false;
                }
            }
            if (filters.assignee_id !== 'all') {
                if (c.assignee_id !== filters.assignee_id) {
                    return false;
                }
            }
            if (filters.creator_id !== 'all') {
                if (c.user_id !== filters.creator_id) {
                    return false;
                }
            }

            return true;
        });
        
        /* comment permissions:
            "addComment"
            "viewComments"
            "assignComment"
            "beAssignedComment"
            "changeCommentStatus"
        */
        var userPermissions = props.commentInfo.permissions;

        var sortBy = 'modified_at';
        var sortDown = true;
        if (this.state) {
            sortBy = this.state.sortBy;
            sortDown = this.state.sortDown;
        }
        filteredComments.sort((a,b)=>{
            var date_a = a[sortBy];
            if (date_a === null) {
                date_a = a.created_at;
            }
            var date_b = b[sortBy];
            if (date_b === null) {
                date_b = b.created_at;
            }
            var da = new Date(date_a);
            var db = new Date(date_b);
            if (da < db) {
                return sortDown ? -1 : 1;
            }
            if (da > db) {
                return sortDown ? 1 : -1;
            }
            return 0;
        });
        
        
        var my_id = props.userHash;
        //console.log("getStoreComments called from " + note + " found " + filteredComments.length + " comments matching filters:" + JSON.stringify(filters));
        return _.map(filteredComments,(c)=>{
            var ct = new Date(c.created_at);
            var editTimeStr = '';
            if (c.modified_at) {
                var et = new Date(c.modified_at);
                editTimeStr = et.toLocaleString(undefined,date_format_options)
            }
            return {
                id: c.id,
                comment: c.comment,
                replies: c.replies,
                status: c.status || 'OPEN',
                timeStr: ct.toLocaleString(undefined,date_format_options),
                editTimeStr: editTimeStr,
                userName: this.getUserNameFromId(c.user_id),
                canResolve: !c.is_client_id && userPermissions.changeCommentStatus,
                canDelete: (c.user_id === my_id) && !c.is_client_id && userPermissions.addComment,
                location: c.location,
                assignee_id: c.assignee_id,
            };
        });
    }
    
    getPossibleAssignees=(props)=>{
        return props.commentInfo && props.commentInfo.possibleAssignees;
    }
    
    onCommentClick=(id,edit,evt)=>{
        evt.stopPropagation();
        if (this.state.newReplyParentID) {
            return; // don't interrupt new reply creation
        }
        if (this.anyActiveCommentChanges()) {
            return; // don't interrupt editing of existing comment
        }        
        var c = _.find(this.state.rawComments,{id:id});
        if (c) {
            var shouldEditText = edit && (c.user_id === this.state.user_id);
            if (this.state.selected_comment !== id || this.state.selected_reply !== '' || (this.state.editingOldText !== shouldEditText)) {
                this.setState({
                    showNewCommentEditor: false,
                    selected_comment: id,
                    selected_reply: '',
                    active_element_comment: c.comment,
                    active_element_status: c.status,
                    active_element_assignee_id: c.assignee_id,
                    editingOldText: shouldEditText,
                },()=>{
                    ShortCourseEditorActions.setSelectedCommentTopic(id);
                });
            }
        }
    }
    
    onReplyClick=(parent_id, id, edit, evt)=>{
        evt.stopPropagation(); // don't click on parent
        if ((this.state.selected_comment === parent_id) && (this.state.selected_reply === id)) {
            return; // no change
        }
        if (this.anyActiveCommentChanges()) {
            return; // don't interrupt current edit
        }
        
        var c = _.find(this.state.rawComments,{id:parent_id});
        if (!c) {
            return;
        }
        var r = _.find(c.replies, {id: id});
        if (r) {
            var shouldEdit = edit && (r.user_id === this.state.user_id);
            this.setState({
                showNewCommentEditor: false,
                newReplyParentID: '',
                selected_comment: parent_id,
                selected_reply: id,
                active_element_comment: r.comment,
                active_element_status: c.status,
                active_element_assignee_id: c.assignee_id,
                editingOldText: shouldEdit,
            },()=>{
                ShortCourseEditorActions.setSelectedCommentTopic(parent_id);
            })
        }
    }
    
    /*goToCommentIdLocation=(id)=>{
        const c = _.find(this.state.rawComments,{id});
        if (c) {
            ShortCourseEditorActions.goToLocation(c.location);
            return true;
        }
    }*/
    
    goToNav=(location,evt)=>{
        evt.stopPropagation();
        ShortCourseEditorActions.goToLocation(location);
    }
    
    deleteComment=(id,evt)=>{
        evt.stopPropagation();
        this.props.openConfirmDialog("Delete Comment","Are you sure?","delete",()=>{
            // Actions.deleteReviewComment(id);
            this.props.commentAction({
                type: Globals.short_course_comment.actions.DELETE_REVIEW_COMMENT,
                id
            });
        });
    }
    
    onChangeCommentStatus=(c,evt)=>{
        var status = evt.target.value;
        evt.stopPropagation();
        if (c.status !== status) {
            if (c.id === this.state.selected_comment && !this.state.selected_reply && this.state.editingOldText) {
                this.setState({active_element_status: status}); // all changes are applied by the 'submit' button
            }
            else {
                this.props.openConfirmDialog(status === 'OPEN' ? "Re-open Comment" : "Resolve Comment","Are you sure?","submit",()=>{
                    // Actions.changeReviewCommentStatus(c.id,status);
                    this.props.commentAction({
                        type: Globals.short_course_comment.actions.CHANGE_REVIEW_COMMENT_STATUS,
                        id: c.id,
                        status
                    });
                })
            }
        }
    }
    
    openNewReplyEditor=(c,evt)=>{
        if (!this.state.permissions.addComment) {
            return;
        }
        evt.stopPropagation(); // don't click the parent
        this.setState({
            selected_comment: '',
            selected_reply: '',
            active_element_comment: '',
            active_element_status: c.status,
            active_element_assignee_id: c.assignee_id,
            editingOldText: false,
            showNewCommentEditor: false,
            newReplyParentID: c.id,
        },()=>{
            ShortCourseEditorActions.setSelectedCommentTopic('');
        });
    }
    
    openNewCommentEditor=()=>{
        if (!this.state.permissions.addComment) {
            return;
        }
        this.setState({
            selected_comment: '',
            selected_reply: '',
            active_element_comment: '',
            active_element_status: 'OPEN', // not currently used for new comment editing but setting to OPEN for consistency ( new comments start in the OPEN status ) 
            active_element_assignee_id: '',
            editingOldText: false,
            showNewCommentEditor: true,
            newReplyParentID: '',
        },()=>{
            ShortCourseEditorActions.setSelectedCommentTopic('');
        });
    }

    submitNewComment=(evt)=>{
        evt.stopPropagation();
        var location = this.state.currentNav;
        var id = genId('com');
        
        // Actions.addReviewComment(id,this.state.active_element_comment,location,this.state.active_element_assignee_id || this.state.default_assignee, this.state.newReplyParentID);
        this.props.commentAction({
            type: Globals.short_course_comment.actions.ADD_REVIEW_COMMENT, 
            id: id,
            comment: this.state.active_element_comment,
            location,
            assignee_id: this.state.active_element_assignee_id || this.state.default_assignee,
            parent_id: this.state.newReplyParentID,
        });
        
        if (this.state.newReplyParentID) {
            var c = _.find(this.state.rawComments,{id:this.state.newReplyParentID});
            var status = this.state.active_element_status; 
            var assignee_id = this.state.active_element_assignee_id;
            if (c.status !== status) {
                // Actions.changeReviewCommentStatus(this.state.newReplyParentID,status);
                this.props.commentAction({
                    type: Globals.short_course_comment.actions.CHANGE_REVIEW_COMMENT_STATUS,
                    id: this.state.newReplyParentID,
                    status
                });
            }
            if (c.assignee_id !== assignee_id) {
                // Actions.changeReviewCommentAssignee(this.state.newReplyParentID,assignee_id);
                this.props.commentAction({
                    type: Globals.short_course_comment.actions.CHANGE_REVIEW_COMMENT_ASSIGNEE, 
                    id: this.state.newReplyParentID,
                    assignee_id,
                });
            }
        }
        
        this.setState({
            showNewCommentEditor: false,
            newReplyParentID: '',
        });
        
        var topic_id = this.state.newReplyParentID ? this.state.newReplyParentID : id;
        var reply_id = this.state.newReplyParentID ? id : '';
        window.setTimeout(()=>{
            // keep existing filter when adding comments
            var filters = {
                location: this.makeFilterLocation(this.state.currentNav,this.state.filter_loc_option), 
                status: this.state.filter_status,
                assignee_id: this.state.filter_assignee_id,
                creator_id: this.state.filter_creator_id,
            };
            var rawComments = this.state.rawComments;
            this.setState({
                selected_comment: topic_id,
                selected_reply: reply_id,
                editingOldText: false,
                rawComments: rawComments,
                comments: this.getStoreComments(this.props, rawComments, filters, "submitNewComment"),
            },()=>{
                ShortCourseEditorActions.setSelectedCommentTopic(topic_id);
            });
        },1);
    }
    
    cancelSubmitNewComment=(evt)=>{
        evt.stopPropagation();
        this.setState({
            showNewCommentEditor: false,
            newReplyParentID: '',
            // also everything deselect does
            selected_comment: '',
            selected_reply: '',
            active_element_comment: '',
            active_element_status: '',
            active_element_assignee_id: '',
            editingOldText: false,
            
        });
    }
    
    onSelectAssignee=(evt)=>{
        evt.stopPropagation();
        this.setState({
            active_element_assignee_id: evt.target.value,
        },()=>{
            if (this.refs.new_text && this.refs.new_text.focus) {
                this.refs.new_text.focus();
            }
        });
    }
    
    onChangeAssignee=(id,evt)=>{
        evt.stopPropagation();
        var assignee_id = evt.target.value;
        if (id === this.state.selected_comment && ( this.state.editingOldText || this.state.newReplyParentID) ) {
            this.setState({active_element_assignee_id: assignee_id});
        }
        else {
            var assignee_name = this.getAssigneeDisplayName(assignee_id);
            this.props.openConfirmDialog("Reassign Comment","Reassign to " + assignee_name + "?","reassign",()=>{
                // Actions.changeReviewCommentAssignee(id,assignee_id);
                this.props.commentAction({
                    type: Globals.short_course_comment.actions.CHANGE_REVIEW_COMMENT_ASSIGNEE, 
                    id,
                    assignee_id,
                });
            });
        }
    }
    
    onSelectAssigneeFilter=(evt)=>{
        var assignee_id = evt.target.value;
        evt.stopPropagation();
        var filters = {
            location: this.makeFilterLocation(this.state.currentNav,this.state.filter_loc_option),
            status: this.state.filter_status,
            assignee_id: assignee_id,
            creator_id: this.state.filter_creator_id,
        };
        var comments = this.getStoreComments(this.props, this.state.rawComments, filters, "onSelectAssigneeFilter");
        var [selected_comment, selected_reply, active_element_comment, active_element_status, active_element_assignee_id] = this.updateSelectedComment(comments,false);
        var stateChanges = {
            filter_assignee_id: assignee_id,
            comments: comments,
            selected_comment: selected_comment,
            selected_reply: selected_reply,
            active_element_comment: active_element_comment,
            active_element_status: active_element_status,
            active_element_assignee_id: active_element_assignee_id,
            editingOldText: false,
        };
        
        if (this.anyActiveCommentChanges(active_element_comment, active_element_status, active_element_assignee_id)) {
            this.props.openConfirmDialog("Change Assignee Filter","You have unsaved changes to the active comment. Continue with filter change and lose edits?","continue",()=>{
                this.setState(stateChanges,()=>{
                    ShortCourseEditorActions.setSelectedCommentTopic(selected_comment);
                });
            });
            return;
        }

        this.setState(stateChanges,()=>{
            ShortCourseEditorActions.setSelectedCommentTopic(selected_comment);
        });
    }
    
    renderAssigneeFilter=()=>{
        var assignees = this.state.assignees;
        return (
            <div className="assignee-filter">
                <label>{'Assignee:'}</label>
                <select className="mzl-dropdown" value={this.state.filter_assignee_id} onChange={this.onSelectAssigneeFilter} onClick={this.noClickThru}>
                    <option key={'all'} value={'all'}>{'All'}</option>
                    {_.map(assignees,function(entry) { return (
                        <option key={entry.user_id} value={entry.user_id}>{entry.display_name}</option>
                    )})}
                </select>
            </div>
        );
    }

    onSelectCreatorFilter=(evt)=>{
        var creator_id = evt.target.value;
        evt.stopPropagation();
        var filters = {
            location: this.makeFilterLocation(this.state.currentNav,this.state.filter_loc_option),
            status: this.state.filter_status,
            assignee_id: this.state.filter_assignee_id,
            creator_id: creator_id,
        };
        var comments = this.getStoreComments(this.props, this.state.rawComments, filters, "onSelectAssigneeFilter");
        var [selected_comment, selected_reply, active_element_comment, active_element_status, active_element_assignee_id] = this.updateSelectedComment(comments,false);
        var stateChanges = {
            filter_creator_id: creator_id,
            comments: comments,
            selected_comment: selected_comment,
            selected_reply: selected_reply,
            active_element_comment: active_element_comment,
            active_element_status: active_element_status,
            active_element_assignee_id: active_element_assignee_id,
            editingOldText: false,
        };
        
        if (this.anyActiveCommentChanges(active_element_comment, active_element_status, active_element_assignee_id)) {
            this.props.openConfirmDialog("Change Assignee Filter","You have unsaved changes to the active comment. Continue with filter change and lose edits?","continue",()=>{
                this.setState(stateChanges,()=>{
                    ShortCourseEditorActions.setSelectedCommentTopic(selected_comment);
                });
            });
            return;
        }

        this.setState(stateChanges,()=>{
            ShortCourseEditorActions.setSelectedCommentTopic(selected_comment);
        });
    }
    
    renderCreatorFilter=()=>{
        var assignees = this.state.assignees;
        return (
            <div className="creator-filter">
                <label>{'Creator:'}</label>
                <select className="mzl-dropdown" value={this.state.filter_creator_id} onChange={this.onSelectCreatorFilter} onClick={this.noClickThru}>
                    <option key={'all'} value={'all'}>{'All'}</option>
                    {_.map(assignees,function(entry) { return (
                        <option key={entry.user_id} value={entry.user_id}>{entry.display_name}</option>
                    )})}
                </select>
            </div>
        );
    }
    
    makeFilterLocation=(loc_param,loc_option)=>{
        switch(loc_option) {
            case 'global':
                return null;
            case 'section':
                return {
                    type: loc_param.type,
                };
            case 'node':
                return {
                    type: loc_param.type,
                    id: (typeof loc_param.id === 'undefined' ?  '' : loc_param.id), // make it blank instead of undefined
                }
        }
        return loc_param; // unexpected
    }
    
    onSelectLocationFilter=(evt)=>{
        evt.stopPropagation();
        var loc_option = evt.target.value;
        if (loc_option === this.state.filter_loc_option) {
            return;
        }
        var filters = {
            location: this.makeFilterLocation(this.state.currentNav,loc_option),
            status: this.state.filter_status,
            assignee_id: this.state.filter_assignee_id,
            creator_id: this.state.filter_creator_id,
        };
        var comments = this.getStoreComments(this.props, this.state.rawComments, filters, "onSelectLocationFilter");
        var [selected_comment, selected_reply, active_element_comment, active_element_status, active_element_assignee_id] = this.updateSelectedComment(comments,false);
        
        var stateChanges = {
            filter_loc_option: loc_option,
            comments: comments,
            selected_comment: selected_comment,
            selected_reply: selected_reply,
            active_element_comment: active_element_comment,
            active_element_status: active_element_status,
            active_element_assignee_id: active_element_assignee_id,
            editingOldText: false,
        };
        if (this.anyActiveCommentChanges(active_element_comment, active_element_status, active_element_assignee_id)) {
            this.props.openConfirmDialog("Change Location Filter","You have unsaved changes to the active comment. Continue with filter change and lose edits?","continue",()=>{
                this.setState(stateChanges,()=>{
                    ShortCourseEditorActions.setSelectedCommentTopic(selected_comment);
                });
            });
            return;
        }
        
        this.setState(stateChanges,()=>{
            ShortCourseEditorActions.setSelectedCommentTopic(selected_comment);
        });
    }

    renderLocationFilter=()=>{
        return (
            <div className="location-filter">
                <label>{'Location:'}</label>
                <select className="mzl-dropdown" value={this.state.filter_loc_option} onChange={this.onSelectLocationFilter} onClick={this.noClickThru}>
                    <option value={'global'}>{'Global'}</option>
                    <option value={'section'}>{'Section'}</option>
                    <option value={'node'}>{'Node'}</option>
                </select>
            </div>
        )
    }
    
    sortComments=()=>{
        var filters = {
            location: this.makeFilterLocation(this.state.currentNav,this.state.filter_loc_option),
            status: this.state.filter_status,
            assignee_id: this.state.filter_assignee_id,
            creator_id: this.state.filter_creator_id,
        };
        this.setState({
            comments: this.getStoreComments(this.props, this.state.rawComments, filters, "sortComments"),
        });
    }
    
    sortToggle=(sortBy)=>{
        if (this.state.sortBy === sortBy) {
            this.setState({sortDown: !this.state.sortDown},this.sortComments);
        }
        else {
            this.setState({
                sortBy: sortBy,
                sortDown: true
            },this.sortComments);
        }
    }
    
    renderSortOptions=()=>{
        return (
            <div className="sort-row">
                <label>{'Sort by:'}</label>
                <button className={"sort-toggle" + (this.state.sortBy === 'modified_at' ? " active":"")} onClick={()=>{this.sortToggle('modified_at')}}>
                {'Date Modified'}
                <span className={"glyphicon " + 
                    (this.state.sortDown ? "glyphicon-chevron-down" : "glyphicon-chevron-up") +
                    (this.state.sortBy === 'modified_at' ? "": " inactive")
                    } aria-hidden="true"/>
                </button>
                <button className={"sort-toggle" + (this.state.sortBy === 'created_at' ? " active":"")} onClick={()=>{this.sortToggle('created_at')}}>
                {'Date Created'}
                <span className={"glyphicon " + 
                    (this.state.sortDown ? "glyphicon-chevron-down" : "glyphicon-chevron-up") +
                    (this.state.sortBy === 'created_at' ? "": " inactive")
                    } aria-hidden="true"/>
                </button>
            </div>
        );
    }

    onSelectStatusFilter=(evt)=>{
        evt.stopPropagation();
        var status = evt.target.value;
        if (status === this.state.filter_status) {
            return;
        }
        var filters = {
            location: this.makeFilterLocation(this.state.currentNav,this.state.filter_loc_option),
            status: status,
            assignee_id: this.state.filter_assignee_id,
            creator_id: this.state.filter_creator_id,
        };
        var comments = this.getStoreComments(this.props, this.state.rawComments, filters, "onSelectStatusFilter");
        var [selected_comment, selected_reply, active_element_comment, active_element_status, active_element_assignee_id] = this.updateSelectedComment(comments,false);
        var stateChanges = {
            filter_status: status,
            comments: comments,
            selected_comment: selected_comment,
            selected_reply: selected_reply,
            active_element_comment: active_element_comment,
            active_element_status: active_element_status,
            active_element_assignee_id: active_element_assignee_id,
            editingOldText: false,
        };
        
        if (this.anyActiveCommentChanges(active_element_comment, active_element_status, active_element_assignee_id)) {
            this.props.openConfirmDialog("Change Status Filter","You have unsaved changes to the active comment. Continue with filter change and lose edits?","continue",()=>{
                this.setState(stateChanges,()=>{
                    ShortCourseEditorActions.setSelectedCommentTopic(selected_comment);
                });
            });
            return;
        }
        
        this.setState(stateChanges,()=>{
            ShortCourseEditorActions.setSelectedCommentTopic(selected_comment);
        });
    }
    
    renderStatusFilter=()=>{
        
        
        
        
        return (
            <div className="status-filter">
                <label>{'Status:'}</label>
                <select className="mzl-dropdown" value={this.state.filter_status} onChange={this.onSelectStatusFilter} onClick={this.noClickThru}>
                    <option value={'OPEN'}>{this.getStatusDisplayName('OPEN')}</option>
                    <option value={'RESOLVED'}>{this.getStatusDisplayName('RESOLVED')}</option>
                    <option value={'all'}>{'All'}</option>
                </select>
            </div>
        );
    }
    
    renderNewCommentEditor=(loc,isReply,c)=>{
        var statusSelector = null;
        var assigneeSelector = null; // UI to set assignee_id for the new comment
        var assignees = this.state.assignees;
        if (assignees.length > 0) {
            //var default_assignee = (assignees.length === 1) ? assignees[0].user_id : '';
            assigneeSelector = (
                <select className="mzl-dropdown" value={this.state.active_element_assignee_id} onChange={this.onSelectAssignee} onClick={this.noClickThru}>
                    <option hidden key={'none'} value={''}>{'assign to...'}</option>
                    {_.map(assignees,function(entry) { return (
                        <option key={entry.user_id} value={entry.user_id}>{entry.display_name}</option>
                    )})}
                </select>
            );
        }
        if (isReply) {
            var topic_status = this.state.active_element_status;
            statusSelector = (
                <div className="comment-status-dropdown">
                    <select className={"mzl-dropdown status-" + topic_status.toLowerCase()} value={topic_status} disabled={!c.canResolve} 
                            onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('comment-toggle-resolve-button',evt)}*/}
                            onChange={(evt)=>{this.setState({active_element_status: evt.target.value})}}
                            onClick={this.noClickThru}>
                        <option className="status-open" value={'OPEN'}>{this.getStatusDisplayName('OPEN')}</option> 
                        <option className="status-resolved" value={'RESOLVED'}>{this.getStatusDisplayName('RESOLVED')}</option> 
                    </select>
                </div>
            );
        }

        
        return (
            <div className="review-comment selected-topic" ref="addCommentUI" onClick={this.noClickThru}>
                {isReply ? null : 
                <span className="comment-location">{this.props.describeCommentLocation(loc)}</span>
                }
                <textarea ref="new_text" autoFocus rows="3" type="text" 
                    onKeyPress={this.handleNewCommentKey}
                    value={this.state.active_element_comment} 
                    placeholder="Enter Comment..." 
                    onClick={this.noClickThru}
                    onChange={(evt)=>{
                        this.setState({
                            active_element_comment:evt.target.value
                        })
                    }}/>
                <div className="bottom-button-row">
                    {statusSelector}
                    {assigneeSelector}
                    <button className="submit-button" 
                        title="Submit" 
                        aria-label="Submit" 
                        onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('new-comment-submit-button',evt)}*/}
                        onClick={this.submitNewComment}>
                        {'submit'}
                    </button>
                    <button className="cancel-button" 
                        title="Cancel" 
                        aria-label="Cancel" 
                        onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('new-comment-submit-button',evt)}*/}
                        onClick={this.cancelSubmitNewComment}>
                        {'cancel'}
                    </button>
                </div>
            </div>
        )
    }
    
    submitCommentChanges=(c)=>{
        var text = this.state.active_element_comment; 
        var status = this.state.active_element_status; 
        var assignee_id = this.state.active_element_assignee_id;
        if (c.comment !== text) {
            // Actions.changeReviewCommentText(c.id,text);
            this.props.commentAction({
                type: Globals.short_course_comment.actions.CHANGE_REVIEW_COMMENT_TEXT,
                id: c.id,
                text,
            });
        }
        if (c.status !== status) {
            // Actions.changeReviewCommentStatus(c.id,status);
            this.props.commentAction({
                type: Globals.short_course_comment.actions.CHANGE_REVIEW_COMMENT_STATUS,
                id: c.id,
                status,
            });
        }
        if (c.assignee_id !== assignee_id) {
            // Actions.changeReviewCommentAssignee(c.id,assignee_id);
            this.props.commentAction({
                type: Globals.short_course_comment.actions.CHANGE_REVIEW_COMMENT_ASSIGNEE,
                id: c.id,
                assignee_id,
            });
        }
        
        // also update rawComments to what we are setting
        var rawComments = this.state.rawComments.slice();
        var ci = _.findIndex(rawComments,{id:c.id});
        if (ci >= 0) {
            rawComments[ci] = _.clone(rawComments[ci]);
            rawComments[ci].comment = text;
            rawComments[ci].status = status;
            rawComments[ci].assignee_id = assignee_id;
        }
        
        window.setTimeout(()=>{
            this.setState({
                selected_comment: '',
                selected_reply: '',
                active_element_comment: '',
                active_element_status: '',
                active_element_assignee_id: '',
                editingOldText: false,
                rawComments: rawComments,
            },()=>{
                ShortCourseEditorActions.setSelectedCommentTopic('');
            });
        },3); // make sure all the actions have taken place, at least internally
    }
    
    submitReplyText=(c,r)=>{
        var text = this.state.active_element_comment; 
        var status = this.state.active_element_status; 
        var assignee_id = this.state.active_element_assignee_id;
        if (r.comment !== text) {
            // Actions.changeReviewReplyText(c.id, r.id,this.state.active_element_comment);
            this.props.commentAction({
                type: Globals.short_course_comment.actions.CHANGE_REVIEW_REPLY_TEXT,
                parent_id: c.id, 
                id: r.id, 
                comment: this.state.active_element_comment
            });
        }
        if (c.status !== status) {
            // Actions.changeReviewCommentStatus(c.id,status);
            this.props.commentAction({
                type: Globals.short_course_comment.actions.CHANGE_REVIEW_COMMENT_STATUS,
                id: c.id, 
                status,
            });
        }
        if (c.assignee_id !== assignee_id) {
            // Actions.changeReviewCommentAssignee(c.id,assignee_id);
            this.props.commentAction({
                type: Globals.short_course_comment.actions.CHANGE_REVIEW_COMMENT_ASSIGNEE,
                id: c.id, 
                assignee_id,
            });
        }
        
        // also update rawComments to what we are setting
        var rawComments = this.state.rawComments.slice();
        var ci = _.findIndex(rawComments,{id:c.id});
        if (ci >= 0) {
            var rc = rawComments[ci] = _.clone(rawComments[ci]);
            rc.replies = rc.replies.slice();
            var rr = _.find(rc.replies, {id: r.id});
            rr.comment = text;
            rc.status = status;
            rc.assignee_id = assignee_id;
        }
        
        this.setState({
            selected_comment: '',
            selected_reply: '',
            active_element_comment: '',
            active_element_status: '',
            active_element_assignee_id: '',
            editingOldText: false,
            rawComments: rawComments,
        },()=>{
            ShortCourseEditorActions.setSelectedCommentTopic('');
        });
    }
    
    cancelSubmitCommentText=(evt)=>{
        evt.stopPropagation();
        this.setState({
            selected_comment: '',
            selected_reply: '',
            active_element_comment: '',
            active_element_status: '',
            active_element_assignee_id: '',
            editingOldText: false,
        });
    }
    
    deselect=(evt)=>{
        evt.stopPropagation();
        this.setState({
            selected_comment: '',
            selected_reply: '',
            active_element_comment: '',
            active_element_status: '',
            active_element_assignee_id: '',
            editingOldText: false,
        },()=>{
            ShortCourseEditorActions.setSelectedCommentTopic('');
        });
    }
    
    getAssigneeDisplayName=(user_id)=>{
        if (!user_id) {
            return '<unassigned>';
        }
        var entry = _.find(this.state.assignees,{user_id: user_id});
        if (!entry) {
            var dn = this.getUserNameFromId(user_id);
            return dn || "<unavailable>";
        }
        return entry.display_name;
    }
    
    handleCommentKey=(c,e)=>{
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            // this.submitCommentChanges(c)
        }
    }
    
    handleNewCommentKey=(e)=>{
        if (e.key === 'Enter' && !e.shiftKey) {
            this.submitNewComment(e);
        }
    }
    
    handleReplyKey=(c,r,e)=>{
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            this.submitReplyText(c,r);
        }
    }
    
    getStatusDisplayName=(status)=>{
         switch(status) {
             case 'OPEN': return Strings['en'].activity_comment.status.OPEN;
             case 'RESOLVED': return Strings['en'].activity_comment.status.RESOLVED;
         }
    }
    
    renderReply=(c,r)=>{
        var ct = new Date(r.created_at);
        var timeStr = ct.toLocaleString(undefined,date_format_options);
        var editTimeStr = '';
        if (r.modified_at) {
            var et = new Date(r.modified_at);
            editTimeStr = et.toLocaleString(undefined,date_format_options)
        }
        var userName = this.getUserNameFromId(r.user_id);
        var textElement;
        var buttonElement = null;
        var extraClasses = "";
        var isSelected = (this.state.selected_comment === c.id) && (this.state.selected_reply === r.id);
        if (isSelected) {
            extraClasses += " selected-reply";
        }
        
        if (r.type === 'STATUS_CHANGE') {
            textElement = (
                <span className="comment-status-change-text">
                {'Status changed from ' + this.getStatusDisplayName(r.status_from) + ' to ' + this.getStatusDisplayName(r.status_to)}
                </span>
            );
        }
        else if (r.type === 'ASSIGNEE_CHANGE') {
            textElement = (
                <span className="comment-status-change-text">
                {'Assigned from ' + this.getAssigneeDisplayName(r.assignee_from) + ' to ' + this.getAssigneeDisplayName(r.assignee_to)}
                </span>
            );
        }
        else if (isSelected && this.state.editingOldText) {
            textElement = (
                <textarea autoFocus rows="3" type="text" value={this.state.active_element_comment} placeholder="Enter Comment..." 
                    onKeyPress={this.handleReplyKey.bind(this,c,r)}
                    onClick={this.noClickThru}
                    onChange={(evt)=>{
                    this.setState({active_element_comment:evt.target.value});
                }}/>
            );
            var assigneeSelector;
            var assignees = this.state.assignees;
            if (assignees.length > 0) {
                //var default_assignee = (assignees.length === 1) ? assignees[0].user_id : '';
                assigneeSelector = (
                    <select className="mzl-dropdown" value={this.state.active_element_assignee_id} onChange={this.onSelectAssignee} onClick={this.noClickThru}>
                        <option hidden key={'none'} value={''}>{'assign to...'}</option>
                        {_.map(assignees,function(entry) { return (
                            <option key={entry.user_id} value={entry.user_id}>{entry.display_name}</option>
                        )})}
                    </select>
                );
            }
            var topic_status = this.state.active_element_status;
            buttonElement = (
                <div className="button-row">
                    <div className="comment-status-dropdown">
                        <select className={"mzl-dropdown status-" + topic_status.toLowerCase()} value={topic_status} disabled={!c.canResolve} 
                                onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('comment-toggle-resolve-button',evt)}*/}
                                onChange={(evt)=>{this.setState({active_element_status: evt.target.value})}}
                                onClick={this.noClickThru}>
                            <option className="status-open" value={'OPEN'}>{this.getStatusDisplayName('OPEN')}</option> 
                            <option className="status-resolved" value={'RESOLVED'}>{this.getStatusDisplayName('RESOLVED')}</option> 
                        </select>
                    </div>
                    {assigneeSelector}
                    <button className="submit-button" 
                        title="Update Reply Text Changes" 
                        aria-label="Update Reply Text Changes" 
                        onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('comment-submit-text-change-button',evt)}*/}
                        onClick={()=>{this.submitReplyText(c,r)}}>
                        {'submit'}
                    </button>
                    <button className="cancel-button" 
                        title="Cancel Reply Text Changes" 
                        aria-label="Cancel Reply Text Changes" 
                        onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('comment-cancel-text-change-button',evt)}*/}
                        onClick={this.cancelSubmitCommentText}>
                        {'cancel'}
                    </button>
               </div>
            );
        }
        else {
            textElement = (
                <p className="comment-text reply-indent" onClick={(evt)=>{this.onReplyClick(c.id,r.id,true,evt)}}>
                   {r.comment}
                </p>
            );
        }
        
        return (
            <div key={r.id} className={"review-reply" + extraClasses} 
                onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('reply-select-button',evt)}*/}
                onClick={(evt)=>{this.onReplyClick(c.id,r.id,false,evt)}}>
                <span className="comment-time">{userName + ' - ' + timeStr}</span>
                {editTimeStr ? 
                <span className="comment-time">{' edited on ' + editTimeStr}</span>
                : null }
                <br/>
                {textElement}
                {buttonElement}
            </div>
        );
    }
    
    renderNewReplyUI=(c)=>{
        if (this.state.newReplyParentID === c.id) {
            return this.renderNewCommentEditor(c.location,true,c);
        }
        if (this.state.newReplyParentID) {
            return null; // Don't show the add reply button if we're already adding a reply here or elsewhere
        }

        if (!this.state.permissions.addComment) {
            return null;
        }
        
        return (
            <button className="text-button" title="reply" aria-label="reply" 
                onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('comment-add-reply-button',evt)}*/}
                onClick={(evt)=>{this.openNewReplyEditor(c,evt)}}>
                {'reply'}
            </button>
        )
    }
    
    noClickThru=(evt)=>{
        evt.stopPropagation();
    }
    
    refreshComments=()=>{
        // Actions.refreshReviewData();
        if (this.props.refreshComments) {
            this.props.refreshComments();
        }
    }
    
    renderTopic=(c)=>{
        let textElement;
        var submitCancelButtons = null;
        var newReplyElement = null;
        var assignDisabled = !this.state.permissions.assignComment; 

        var topic_comment = c.comment;
        var topic_assignee_id = c.assignee_id;
        var topic_status = c.status;
        var isSelected = ((this.state.selected_comment === c.id) && !this.state.selected_reply);
        if (isSelected) {
            topic_comment = this.state.active_element_comment;
            topic_status = this.state.active_element_status
            topic_assignee_id = this.state.active_element_assignee_id;
        }
        var revokedAssignee = (topic_assignee_id && !_.find(this.state.assignees,{user_id:topic_assignee_id}));
        
        var extraClasses = "";
        if (isSelected) {
            extraClasses += " selected-topic";
        }
        var editMode = isSelected && this.state.editingOldText;
        var otherEditMode = (!editMode && (this.state.newReplyParentID || this.state.editingOldText)); // true if editing a reply or some other comment
        
        if (editMode) {
            textElement = (
                <textarea autoFocus rows="3" type="text" value={topic_comment} placeholder="Enter Comment..." 
                    onKeyPress={this.handleCommentKey.bind(this,c)}
                    onClick={this.noClickThru}
                    onChange={(evt)=>{
                        this.setState({
                            active_element_comment:evt.target.value
                        })
                    }}/>
            );
            submitCancelButtons = [
                <button key='submit' className="submit-button" 
                    title="Submit Topic Changes" 
                    aria-label="Submit Topic Changes" 
                    onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('comment-submit-changes-button',evt)}*/}
                    onClick={(evt)=>{
                        evt.stopPropagation();
                        this.submitCommentChanges(c);
                        }}>
                    {'submit'}
                </button>,
                <button key='cancel' className="cancel-button" 
                    title="Cancel Topic Changes" 
                    aria-label="Cancel Topic Changes" 
                    onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('comment-cancel-changes-button',evt)}*/}
                    onClick={this.cancelSubmitCommentText}>
                    {'cancel'}
                </button>
            ];
        }
        else {
            textElement = (
                <p className="comment-text" title="click to edit" onClick={(evt)=>{this.onCommentClick(c.id,true,evt)}}>{topic_comment || '---'}</p>
            );
            newReplyElement = this.renderNewReplyUI(c);
        }
        
        //var sameNav = c.location && _.isEqual(c.location,this.state.currentNav);
        var badNav = false;
        if (this.props.canNavigateToLocation && !this.props.canNavigateToLocation(c.location)) {
            badNav = true;
        }
        var navTitle = "Go To Context";
        if (badNav) {
            navTitle += " (missing)";
        }
        
        var statusSelector;
        var assigneeSelector;
        
        if (!otherEditMode) {
            assigneeSelector  = (
                <div className="assignee-block">
                    <select className="mzl-dropdown" value={topic_assignee_id || ''} onChange={(evt)=>{this.onChangeAssignee(c.id,evt)}} onClick={this.noClickThru}>
                        {assignDisabled ? 
                        <option hidden key={'none'} value={''}>{'assign to...'}</option> 
                        :
                        <option hidden key={'none'} value={''}>{'unassigned'}</option> 
                        }
                        {revokedAssignee ? 
                        <option hidden key={topic_assignee_id} value={topic_assignee_id}>{this.getUserNameFromId(topic_assignee_id)||'unknown'}</option> 
                        : null }
                        {_.map(this.state.assignees,function(entry) { return (
                            <option key={entry.user_id} disabled={assignDisabled} value={entry.user_id}>{entry.display_name}</option>
                        )})}
                    </select>
                </div>
            );
            statusSelector = (
                <div className="comment-status-dropdown">
                    <select className={"mzl-dropdown status-" + topic_status.toLowerCase()} value={topic_status} disabled={!c.canResolve} 
                            onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('comment-toggle-resolve-button',evt)}*/}
                            onChange={(evt)=>{this.onChangeCommentStatus(c,evt)}} onClick={this.noClickThru}>
                        <option className="status-open" value={'OPEN'}>{this.getStatusDisplayName('OPEN')}</option> 
                        <option className="status-resolved" value={'RESOLVED'}>{this.getStatusDisplayName('RESOLVED')}</option> 
                    </select>
                </div>
            );
        }

        var replyElements = _.map(c.replies,(r)=>{
            return this.renderReply(c,r);
        });
        
        return (
            <div key={c.id} ref={"scrollto_" + c.id} className={"review-comment" + extraClasses}
                onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('comment-select-button',evt)}*/}
                onClick={(evt)=>{this.onCommentClick(c.id,false,evt)}}>
                
                { c.canDelete ?
                <button className="bare-text-button glyph comment-delete" 
                    title="Delete Comment" aria-label="Delete Comment" 
                    onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('comment-delete-button',evt)}*/}
                    onClick={(evt)=>{this.deleteComment(c.id,evt)}}>
                    <span className="glyphicon glyphicon-trash" aria-hidden="true"></span>
                </button> : null }

                <button className={"comment-nav" + (badNav ? " bad-nav" : "")}
                    title={navTitle} aria-label={navTitle} 
                    disabled={!c.location || badNav}
                    onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('comment-nav-button',evt)}*/}
                    onClick={(evt)=>{this.goToNav(c.location,evt)}}>
                    {'goto'}
                </button>
                
                <span className="comment-location">{this.props.describeCommentLocation(c.location)}</span>
                <span className="comment-time">
                    {c.userName + ' - ' + c.timeStr}
                </span>
                {c.editTimeStr ? 
                <span className="comment-time">{' edited on ' + c.editTimeStr}</span>
                : null }
                {textElement}
                {replyElements}
                <div className="bottom-button-row">
                    {statusSelector}
                    {assigneeSelector}
                    {newReplyElement}
                    {submitCancelButtons}
                </div>
            </div>
        )
    } // renderTopic
    
    /*isEditingComment=()=>{
        return this.state.showNewCommentEditor;
    }*/
    
    render() {
        var newCommentButton = null;
        if (this.state.permissions && this.state.permissions.addComment) {
            newCommentButton = (
                <button className="comment-insert" 
                    title="Start New Topic" aria-label="Start New Topic" 
                    onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('comment-insert-button',evt)}*/}
                    disabled={this.state.showNewCommentEditor}
                    onClick={this.openNewCommentEditor}>
                    {'add comment'}
                </button>
            );
        }
        
        let refreshButton=(
            <button className="refresh-button"
                title="retrieve latest comments"
                onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('comment-refresh-button',evt)}*/}
                onClick={this.refreshComments}>refresh</button>
        );
        
        return (
            <div className="comment-editor">
                <div className="filter-bar">
                    {this.renderAssigneeFilter()}
                    {this.renderStatusFilter()}
                    {this.renderLocationFilter()}
                    {this.renderCreatorFilter()}
                    {this.renderSortOptions()}
                    <div className="bottom-row">
                        {newCommentButton}
                        {refreshButton}
                    </div>
                </div>
                <div className="comment-scroll-area" ref="csa" onClick={this.deselect}>
                    {(this.state.comments && this.state.comments.length === 0) ?
                        <div className="info-text">{'no comments...'}</div>
                        :
                        _.map(this.state.comments,(c)=>{ return this.renderTopic(c);})
                    }
                    {this.state.showNewCommentEditor ? this.renderNewCommentEditor(this.state.currentNav,false) : null}
                </div>
                <div className="comment-footer" onClick={this.deselect}>
                    {newCommentButton}
                    {refreshButton}
                </div>
            </div>
        )
    }
}; // ReviewCommentEditor

ReviewCommentEditor.propTypes = propTypes;
ReviewCommentEditor.defaultProps = defaultProps;


module.exports = ReviewCommentEditor;

